import { SearchRemoveIcon } from "@bookingcom/bui-assets-react/streamline";
import { Icon, Button, Text } from "@bookingcom/bui-react";
import React from "react";
import Frame from "../Frame/index.js";
import { useSelector } from "react-redux";
import { getSearch } from "../../../store/search/selectors.js";
import { t, useI18n } from "@bookingcom/lingojs-react";
import styles from "./SearchResults.desktop.module.css";
const FailedSearchResults = ({ onClickExpandToCitySearch }) => {
    const i18n = useI18n();
    const search = useSelector(getSearch);
    return (React.createElement(Frame, { mt: 6, mb: 6, attributes: { style: { minHeight: "40vh" } } },
        React.createElement(Frame, { m: 3, alignItems: "center" },
            React.createElement(Icon, { svg: SearchRemoveIcon, size: "small", className: styles.searchRemoveIcon }),
            React.createElement(Text, { variant: "headline_2" }, i18n.trans(t("flights_search_no_results_header")))),
        React.createElement(Frame, { alignItems: "center" },
            React.createElement(Text, { variant: "body_2" },
                i18n.trans(t("flights_search_no_results_copy_desktop")),
                " ")),
        search.type !== "MULTISTOP" && (React.createElement(Frame, { alignItems: "center", m: 6 },
            React.createElement(Button, { onClick: onClickExpandToCitySearch }, i18n.trans(t("flights_search_no_results_nearbyairports_cta")))))));
};
export default FailedSearchResults;
